var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-secondary rounded mb-4",class:{ 'border-secondary': _vm.isVisible }},[(_vm.isVisible)?_c('div',{staticClass:"w-100 p-0"},[_c('ActionGroup',{ref:"actionGroup",attrs:{"selectedReportNotificationType":_vm.selectedReportNotificationType,"current-query":_vm.query,"filter":_vm.filter}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }